import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoroutingRoutingModule } from './autorouting-routing.module';
import { SkillsComponent } from './components/skills/skills.component';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { DirectivesModule } from 'app/directives/directives.module';
import { AgGridModule } from 'ag-grid-angular/src/aggrid.module';
import { SkillsService } from './skills.service';
import { AddNewSkillComponent } from './components/skills/components/add-new-skill/add-new-skill.component';
import { ReactiveFormsModule } from '@angular/forms';
import {AutoroutingSettingsComponent} from './components/autorouting-settings/autorouting-settings.component';
import {AutoroutingService} from './autorouting.service';
import {AutoroutingJobsComponent} from './components/autorouting-jobs/autorouting-jobs.component';
import {GridComponentsModule} from '../A2-utils/grid-components/grid-components.module';
import {BooleanCheckComponent} from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import {AutoRoutingResultsModule} from '../auto-routing-results/auto-routing-results.module';
import { MultiSelectDropdownModule } from '../A2-utils/multi-select-dropdown/multi-select-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    AutoroutingRoutingModule,
    Trip2ThemeModule,
    AgGridModule.withComponents([
      BooleanCheckComponent
    ]),
    DirectivesModule,
    ReactiveFormsModule,
    GridComponentsModule,
    MyDateRangePickerModule,
    AutoRoutingResultsModule,
    MultiSelectDropdownModule
  ],
  declarations: [
    SkillsComponent,
    AddNewSkillComponent,
    AutoroutingSettingsComponent,
    AutoroutingJobsComponent
  ],
  exports: [
    AutoroutingSettingsComponent,
    AutoroutingJobsComponent
  ],
  providers: [
    SkillsService,
    AutoroutingService,
  ]
})
export class AutoroutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/autorouting/autorouting.module.ts